import React, {useState, useEffect} from 'react';
import {useSelector} from 'react-redux';
import {isMobile} from 'react-device-detect';
import BtnSubmit from 'app/Components/Shared/Buttons/BtnSubmit';
import Tooltip from 'app/Components/Shared/Tooltip/Tooltip';
import useEnterKeyPress from '../hooks/useEnterKeyPress';
import {useSelectUpdatePaymentBan} from '../hooks/useSelectUpdatePaymentBan';
import UpdatePaymentBanSelectItem from '../SharedComponents/UpdatePaymentBanSelectItem';
import {stepEnum} from '../Constants/debtPaymentEnum';
import {selectSelectedBanData, selectServerData, selectEpiData} from '../DebtAndUpdatePaymentBlockSlice';
import Image from 'app/Components/Shared/Image/image';
import {dwhUpdatePaymentMethodReport, DwhActionType, DWHMessageText, DWHStatus} from '../reports/dwhReports';

const ACCOUNTS_LIST_TOOLTIP_ID = 'update-payment-ban-select-accounts-tooltip';
const infoIcon = require('../images/info-outline.svg');

const SelectUpdatePaymentBan = () => {
  const {displayBans, selectedBansForPaymentUpdate, showDebtAccountsTooltip, actions} = useSelectUpdatePaymentBan();
  const selectedBanData = useSelector(selectSelectedBanData);
  const allBans = useSelector(selectServerData);
  const epiData = useSelector(selectEpiData);
  const loginData = useSelector((state) => state.authentication.loginData);
  const [showError, setShowError] = useState(false);

  useEffect(() => {
    dwhUpdatePaymentMethodReport({
      banData: selectedBanData,
      loginData,
      allBans,
      selectedBanNumbers: selectedBansForPaymentUpdate,
      actionType: DwhActionType.AccountsSelectionPage,
      messageText: DWHMessageText.AccountsSelectionPageDisplayed,
      status: DWHStatus.Ongoing,
      lastPaymentTypeValidation: epiData?.lastPaymentTypeValidation,
    });
  }, []);

  const handleContinue = () => {
    if (!selectedBansForPaymentUpdate?.length) {
      setShowError(true);
      return;
    }
    setShowError(false);
    dwhUpdatePaymentMethodReport({
      banData: selectedBanData,
      loginData,
      allBans,
      selectedBanNumbers: selectedBansForPaymentUpdate,
      actionType: DwhActionType.AccountsSelectionPage,
      messageText: DWHMessageText.AccountsSelectionPageButtonClicked,
      status: DWHStatus.Ongoing,
      lastPaymentTypeValidation: epiData?.lastPaymentTypeValidation,
    });
    actions.goToStep(stepEnum.CREDITCARD);
  };

  useEnterKeyPress(handleContinue, !selectedBansForPaymentUpdate?.length);

  return (
    <div className='debtpayment-step update-payment-ban-select-step'>
      <div className={`update-payment-ban-select-step__title ${isMobile ? 'm-title' : 'l-title'} bold`}>
        לפני שנתקדם, האם לעדכן אמצעי תשלום בחשבון נוסף?
      </div>

      <div className='update-payment-ban-select-step__list'>
        {displayBans.map((ban) => (
          <UpdatePaymentBanSelectItem
            key={ban.banNumber}
            ban={ban}
            checked={selectedBansForPaymentUpdate?.includes(ban.banNumber)}
            onToggle={(banNumber, checked) => {
              setShowError(false);
              actions.toggleBanSelection(banNumber, checked);
            }}
          />
        ))}
      </div>

      {showDebtAccountsTooltip && (
        <div className='update-payment-ban-select-step__tooltip-link' id={ACCOUNTS_LIST_TOOLTIP_ID} role='button' tabIndex={0}>
          <Image className='update-payment-ban-select-step__info-icon' src={infoIcon} alt='' />
          <span className='update-payment-ban-select-step__tooltip-trigger'>למה לא כל החשבונות מופיעים ברשימה?</span>
          <Tooltip
            text='חשבונות עם חוב לא מופיעים ברשימה כי לא ניתן לעדכן בהם אמצעי תשלום'
            target={ACCOUNTS_LIST_TOOLTIP_ID}
            placement='top'
            trigger='click'
            cellcomdefault={true}
            showCloseButton={true}
            onClose={() => document.getElementById(ACCOUNTS_LIST_TOOLTIP_ID)?.click()}
            additionalClassName='update-payment-ban-select-tooltip'
          />
        </div>
      )}

      <div className='continue-button'>
        {showError && <span className='error'>כדי להמשיך יש לבחור לפחות חשבון אחד</span>}
        <BtnSubmit text='המשך' onclick={handleContinue} />
      </div>
    </div>
  );
};

export default SelectUpdatePaymentBan;
